const API_URL = process.env.REACT_APP_API_URL;

export const fetchAllSubjects = async () => {
  const res = await fetch(`${API_URL}/api/note-subjects/all`);
  const data = await res.json();
  if (!data.success) throw new Error("Failed to fetch subjects");
  return (data.data || []).map((s) => ({ label: s.title, value: s._id }));
};

export const fetchModulesBySubject = async (subjectId) => {
  if (!subjectId) return [];
  const res = await fetch(`${API_URL}/api/note-subjects/${subjectId}/modules`);
  const data = await res.json();
  if (!data.success) throw new Error("Failed to fetch modules");
  return (data.data || []).map((m) => ({ label: m.title, value: m._id }));
};

export const fetchTopicsByModule = async (moduleId) => {
  if (!moduleId) return [];
  const res = await fetch(`${API_URL}/api/note-modules/${moduleId}/topics`);
  const data = await res.json();
  if (!data.success) throw new Error("Failed to fetch topics");
  return (data.data || []).map((t) => ({ label: t.title, value: t._id }));
};

export const fetchSectionsByTopic = async (topicId) => {
  if (!topicId) return [];
  const res = await fetch(`${API_URL}/api/note-topics/${topicId}/distinct-sections`);
  const data = await res.json();
  if (!data.success) throw new Error("Failed to fetch sections");
  return (data.data || []).map((s) => ({ label: s, value: s }));
};
